// extracted by mini-css-extract-plugin
module.exports = {"error_text":"error-text_error_text__9yhlX"};